module.exports = __webpack_public_path__ + "static/NFTs-74004b6bd9c92d1114a09679aacca73d.webp";